'use strict';

var $ = require('jquery');
var Animation = require('../lib/Animation.js');
var AnimationEasing = require('../lib/AnimationEasing.js');
var Range = require('../lib/Range.js');

function setupAnimations() {
	var debug = false;
	
	function setup(manager) {
		// Cards
		var $cards = $('.cards');
		manager.addArea(new Animation.Area('cards--animates', 0, 0, 1, [new Animation.StyleClass($cards, 'cards--animates')]));
		$cards.each(function() {
			var $this = $(this);
			var start = $this.offset().top;
			manager.addArea(new Animation.Area('cards trigger animation', start, start, 1, [new Animation.StyleClassRemoveOnce($this, 'cards--animates')]));
		});
		
		// Rich Content
		var $richContent = $('.richContent');
		manager.addArea(new Animation.Area('richContent--animates', 0, 0, 1, [new Animation.StyleClass($richContent, 'richContent--animates')]));
		$richContent.each(function() {
			var $this = $(this);
			var start = $this.offset().top;
			manager.addArea(new Animation.Area('richContent trigger animation', start, start, 1, [new Animation.StyleClassRemoveOnce($this, 'richContent--animates')]));
		});
	}
	
	var manager = new Animation.Manager({setup: setup, indicator: .8, debug: debug});

	// Start animation
	manager.start();
	
	// Start animation but turn off if in or enter mobile view.
	Animation.runConditionalOnViewport(manager, function(state) {return state !== 'mobile';});
}

function setupCarousel() {
	var $slides = $('.carousel .slide');
	var $images = $('.carousel .responsiveImage');
	var $indicators = $('.carousel .indicator');
	var previousIndex;
	var currentIndex = 0;

	var SlideState = {
		inactive: 0,
		active: 1,
		wasActive: 3
	};
	
	function switchTo(newIndex) {
		changeState(previousIndex, SlideState.inactive);
		changeState(currentIndex, SlideState.wasActive);
		changeState(newIndex, SlideState.active);

		previousIndex = currentIndex;
		currentIndex = newIndex;
		
		restartSwitchTimeout();
	}
	function changeState(index, state) {
		if (index === undefined)
			return;

		if (state === SlideState.inactive) {

			$slides.eq(index).removeClass('slide--active');
			$images.eq(index).removeClass('responsiveImage--active');
			$indicators.eq(index).removeClass('indicator--active');
			
			$slides.eq(index).removeClass('slide--wasActive');
			$images.eq(index).removeClass('responsiveImage--wasActive');
			$indicators.eq(index).removeClass('indicator--wasActive');

		} else if (state === SlideState.active) {

			$slides.eq(index).addClass('slide--active');
			$images.eq(index).addClass('responsiveImage--active');
			$indicators.eq(index).addClass('indicator--active');

		} else if (state === SlideState.wasActive) {
			
			$slides.eq(index).removeClass('slide--active');
			$images.eq(index).removeClass('responsiveImage--active');
			$indicators.eq(index).removeClass('indicator--active');
			
			$slides.eq(index).addClass('slide--wasActive');
			$images.eq(index).addClass('responsiveImage--wasActive');
			$indicators.eq(index).addClass('indicator--wasActive');

		} 
	}
	function next() {
		var newIndex = currentIndex + 1;
		if (newIndex >= $slides.length) {
			newIndex = 0;
		}
		switchTo(newIndex);
	}
	
	// Auto switch slide on an interval
	var startSwitchTimeoutID = undefined;
	function restartSwitchTimeout() {
		clearTimeout(startSwitchTimeoutID);
		startSwitchTimeoutID = setTimeout(next, 7000);
	}
	restartSwitchTimeout();
	
	// Create buttons used to switch slide
	$indicators.on('click', function() {
		var $this = $(this);
		var newIndex = $this.attr('data-index');
		switchTo(newIndex);
	});

	// Scroll down arrow
	document.querySelector('.carousel__mouseDownIcon').addEventListener('click', function(event) { 
		event.preventDefault();
		var selector = this.href.substring(this.href.indexOf('#') + 1);
		document.getElementById(selector).scrollIntoView();
	});
}

module.exports = {
	init : function() {
		if ($('body.__entry').length === 0)
			return;
		
		setupAnimations();
		setupCarousel();
	}
};

